import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bg-light w-100 min-vh-100" };
const _hoisted_2 = { class: "container-fluid p-5" };
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import Navigation from './Navigation.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TenantLayout',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Navigation),
                    _createElementVNode("main", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]),
                _createVNode(_unref(ConfirmDialog)),
                _createVNode(_unref(Toast))
            ], 64));
        };
    }
});
